export enum AgeGroupActionTypes {
    API_RESPONSE_SUCCESS = '@@ageGroups/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@ageGroups/API_RESPONSE_ERROR',

    GET_AGE_GROUPS = '@@ageGroups/GET_AGE_GROUPS',
}
